/* eslint-disable */
"use strict";
import UserActions from './UserRedux'

const PeriodicMiddleware = (function () {
  const exchangeUpdateRate = 10800 // 3 hours  3600 // hourly
  let lastChecked = null
  let lastToken = null
  let lastCurrency = null
  
  return store => next => action => {
    const state = store.getState()
    const token = state.auth.token
    const currentUserCurrency = state.auth.user ? state.auth.user.Currency : 'USD'
    const loggedIn = token != null
    // console.log(`PeriodicMiddleware action.type: ${action.type} token ${token} loggedIn ${loggedIn}`)
    if (loggedIn) {
      const now = Date.now() / 1000
      const { exchangeRates } = state.user
      const { phase, modified, userCurrency = 'USD' } = exchangeRates
      const userHasChanged = token != lastToken
      const currencyHasChanged = lastCurrency != currentUserCurrency
      // note: if we used exchangeRates.modified or userCurrency, and API fails, you could get continuous api calls here, use local var
      if (lastChecked == null || (now - lastChecked > exchangeUpdateRate) || currencyHasChanged) {
        console.log(`PeriodicMiddleware calling getExchangeRates, currentUserCurrency ${currentUserCurrency}`)
        lastChecked = now
        lastToken = state.auth.token
        lastCurrency = currentUserCurrency
        store.dispatch(UserActions.getExchangeRates())
      }
    }
    return next(action)
  }
})()

export default PeriodicMiddleware
